// invest_FE/src/components/topbar/ActiveUserCount.js
import React, { useState } from 'react';
import ActiveUsersDetails from './ActiveUsersDetails'; // Import the new modal component
import './ActiveUserCount.css';

/**
 * Displays the number of active users on the site.
 * Receives its data from the SessionTracker component.
 * @param {{
 *   activeUsers: { total: number, registered: number, guests: number },
 *   error: string | null
 * }} props
 */
const ActiveUserCount = ({ activeUsers, error }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handleCloseModal = (e) => {
    // Prevent any default browser action (like form submission) and stop the event from bubbling up.
    e.preventDefault();
    setIsModalOpen(false);
  };

  if (error) {
    return (
      <div className="active-user-count-container error" title={error}>
        <span className="icon-group">👥</span>
        <span className="count-text">?</span>
      </div>
    );
  }

  const { total, registered, guests } = activeUsers;

  return (
    <>
      <button type="button" className="active-user-count-container" title={`Registered: ${registered}, Guests: ${guests}\nClick to see details`} onClick={handleOpenModal}>
        <span className="icon-group">👥</span>
        <span className="count-text">{total}</span>
      </button>
      <ActiveUsersDetails isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default ActiveUserCount;
